/**
 * Safely removes a class name from an element
 */
export function removeClass(selector, className) {
  const elem = document.querySelector(selector);

  // check for element first
  if (! elem) {
    return;
  }

  if (elem.classList.contains(className)) {
    elem.classList.remove(className);
  }
}

/**
 * Toggle Function
 * @param {string} toggler     The toggle handle
 * @param {string} target      Element in which to toggle the class
 * @param {string} toggleClass Class name to toggle on or off
 */
export function toggle(toggler, target, toggleClass = 'toggled') {
  const toggleHandle = document.querySelector(toggler);
  const targetElement = document.querySelector(target);

  if (toggleHandle && targetElement) {
    toggleHandle.addEventListener('click', () => {
      targetElement.classList.toggle(toggleClass);
    });
  }
}

export function anchorLinkHandler(e) {
  // Bail if no event is triggered.
  if (! e) {
    return;
  }

  // Return distance.
  const distanceToTop = (el) => Math.floor(el.getBoundingClientRect().top);
  // Prevent default.
  e.preventDefault();

  // Get target.
  const targetID = this.getAttribute('href');

  // Bail if no ID exists.
  // Verify that the target is a valid anchor reference.
  if (! targetID || ! targetID.match(/^#[^#]+$/)) {
    return;
  }

  // Bail if no anchor exists.
  const targetAnchor = document.querySelector(targetID);
  if (! targetAnchor) {
    return;
  }

  // Get anchor distance.
  const originalTop = distanceToTop(targetAnchor);

  window.scrollBy({ top: originalTop - 100, left: 0, behavior: 'smooth' });

  const checkIfDone = setInterval(() => {
    const atBottom = window.innerHeight + window.scrollY
      >= document.body.offsetHeight - 2;
    if (0 === distanceToTop(targetAnchor) || atBottom) {
      targetAnchor.tabIndex = '-1';
      targetAnchor.focus();
      window.history.pushState(', ', targetID);
      clearInterval(checkIfDone);
    }
  }, 100);
}

export default {
  anchorLinkHandler,
  removeClass,
  toggle,
};
